/* eslint-disable react/no-danger */
import Link from 'next/link';
import Image from 'next/image';
import { FirstWrapper, Wrapper } from './styles';

const Post = ({ post, first = false }) => {
  const featuredImage = post?._embedded?.['wp:featuredmedia'];
  const category = post?._embedded?.['wp:term'][0][0];

  let titleCategory = post.title.rendered.replace(/(<([^>]+)>)/ig, '');
  if (titleCategory.length > 60) {
    titleCategory = `${titleCategory.substring(0, 60)}...`;
  }

  let titleTwoCategory = post.title.rendered.replace(/(<([^>]+)>)/ig, '');
  if (titleTwoCategory.length > 46) {
    titleTwoCategory = `${titleTwoCategory.substring(0, 46)}...`;
  }

  let excerptCategory = post.excerpt.rendered.replace(/(<([^>]+)>)/ig, '');
  if (excerptCategory.length > 134) {
    excerptCategory = `${excerptCategory.substring(0, 134)}...`;
  }

  let excerptTwoCategory = post.excerpt.rendered.replace(/(<([^>]+)>)/ig, '');
  if (excerptTwoCategory.length > 134) {
    excerptTwoCategory = `${excerptTwoCategory.substring(0, 134)}...`;
  }

  if (first) {
    return (
      <FirstWrapper>
        {featuredImage && (
          <Link href={`/br/blog/${post.slug}`} as={`/br/blog/${post.slug}`}>
            <a className="image">
              <Image
                priority
                src={featuredImage[0]?.source_url}
                height={400}
                width={600}
                alt={featuredImage[0]?.alt_text}
              />
            </a>
          </Link>
        )}

        <div className="list-items">
          <div className="category">{category.name}</div>
          <Link href={`/br/blog/${post.slug}`} as={`/br/blog/${post.slug}`}>
            <a
              className="title"
            >{titleCategory}</a>
          </Link>
          <div
            className="excerpt"
          >{excerptCategory}</div>
        </div>
      </FirstWrapper>
    );
  }
  return (
    <>
      <Wrapper>
        <div className="list-cardblog">
          <div className="list-container">
            {featuredImage && (
              <Link href={`/br/blog/${post.slug}`} as={`/br/blog/${post.slug}`}>
                <a>
                  <Image
                    priority
                    className="image"
                    src={featuredImage[0].source_url}
                    height={271}
                    width={330}
                    layout="responsive"
                    alt={featuredImage[0].alt_text}
                  />
                </a>
              </Link>
            )}
            <div className="list-card-items">
              <div className="category">{category.name}</div>
              <Link href={`/br/blog/${post.slug}`} as={`/br/blog/${post.slug}`}>
                <a
                  className="title"
                >{titleTwoCategory}</a>
              </Link>
              <div
                className="excerpt"
              >
                {excerptTwoCategory}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default Post;
